import styled, { css } from "styled-components";

import Search from "core/ReusableIcons/Search";
import Grid from "core/Grid";

import { spacingWithBreakpoints } from "core/spacing";
import breakpoints from "core/breakpoints";
import colors from "core/colors";

export const HeroLandingPageContainer = styled.div`
    /* mobile: */
    ${({ mobileMinHeight }) => `min-height: ${mobileMinHeight};`}
    
    ${({ mobileImg, bgSizeMobile, bgPositionMobile }) =>
        mobileImg &&
        css`
            background-image: url(${mobileImg});
            background-repeat: no-repeat;
            background-position: ${bgPositionMobile
                ? bgPositionMobile
                : `center bottom`};
            background-size: ${bgSizeMobile ? bgSizeMobile : `auto 100%`};
        `}

    /* tablet: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        ${({ tabletMinHeight }) => `min-height: ${tabletMinHeight};`}

        ${({ tabletImg, bgSizeTablet, bgPositionTablet }) =>
            tabletImg &&
            css`
                background-image: url(${tabletImg});
                background-repeat: no-repeat;
                background-position: ${bgPositionTablet
                    ? bgPositionTablet
                    : `right bottom`};
                background-size: ${bgSizeTablet ? bgSizeTablet : `cover`};
            `}
    }
    /* desktop: */
    @media (min-width: ${breakpoints.desktop.rem}) {
        ${({ desktopMinHeight }) => `min-height: ${desktopMinHeight};`}

        ${({ desktopImg, bgSizeDesktop, bgPositionDesktop }) =>
            desktopImg &&
            css`
                background-image: url(${desktopImg});
                background-repeat: no-repeat;
                background-position: ${bgPositionDesktop
                    ? bgPositionDesktop
                    : `100%`};
                background-size: ${bgSizeDesktop ? bgSizeDesktop : `auto 100%`};
            `}
    }
`;

export const HeadingAndInputContainer = styled.div`
    button {
        display: none;
        /* hide search type toggle button & submit button since this hero is only for photos; neither are needed */
    }

    input[type="search"] {
        height: 3rem; /* 48px */
        border-radius: 3rem; /* 48px */
        background: ${colors.primary.diamond};
        padding: 0.5968rem 1.5rem 0.5968rem 3.375rem;
        /* 9.5px 24px 9.5px 54px = search icon is 24px from the left + 18px for search icon width - 4px because of spacing + 16px distance between placeholder and search icon */
        width: 100%; /* this width is different on tablet + desktop */
    }

    h1 {
        ${spacingWithBreakpoints.XL4Top}
    }

    /* tablet + desktop: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        input[type="search"] {
            width: 296px;
        }
    }
`;

export const SearchContainer = styled.div`
    height: 3rem; /* 48px */

    /* mobile-only: */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        margin-bottom: 3rem; /* 48px */
    }
`;

export const SearchIcon = styled(Search)`
    position: absolute;
    margin-left: 1.5rem; /* 24px */
    margin-top: 0.875rem; /* 14px */
`;

export const MobileImg = styled.img`
    width: 100%;
    height: auto;
`;

// for icons landing-specific:
export const IconsLandingPageIconsContainer = styled(Grid)`
    && {
        text-align: right;

        /* mobile-only: */
        @media (max-width: ${breakpoints.beforeTablet.rem}) {
            padding-top: 0 !important; // does not work without !important
            padding-bottom: 0 !important; // does not work without !important
        }
    }
`;
